import NewProjectSourceWizardReducer from './NewProjectSourceWizardReducer';

export default from './NewProjectSourceWizardContainer';
export const NewProjectSourceWizardReducers = {
  NewProjectSourceWizardReducer,
};
